import {routineForChildren, routineForComponent} from '@im-ng/route';

export const EXTERNALS_SLUG = 'externals';
export const EXTERNALS_ANNOUNCE_SLUG = 'announce';



export const EXTERNALS_ANNOUNCE_ROUTINE = routineForComponent(
	'EXTERNALS_ANNOUNCE',
	[EXTERNALS_SLUG, EXTERNALS_ANNOUNCE_SLUG],
	{
		// icon: 'menu24:ai-trained-model'
	}
);


export const EXTERNALS_ROUTINE = routineForChildren(
	'EXTERNALS',
	[EXTERNALS_SLUG],
	{
		// icon: 'menu24:ai-trained-model',
		children: [
			EXTERNALS_ANNOUNCE_ROUTINE.menu
		]
	}
);


